(function(){
  'use strict';
  if(window.__mxpPromoBridgeV3)return;
  window.__mxpPromoBridgeV3=true;

  var loading=null;
  var SINGLE_GIFT_CODE='MXP1GIFT9ZK7';
  var TXN='mxpPromoGiftTxnV42';

  var V={
    charger2a:58758755385676,
    lightning:58758754763084,
    usbAC:58969799426380,
    macL:59005547315532,
    macT:59005547741516,
    macUsbC:59005548003660,
    pin30:59005664854348,
    microUsb:59005665116492
  };

  var SINGLE_GIFT_IDS={};
  [V.macL,V.macT,V.macUsbC,V.pin30,V.microUsb].forEach(function(id){
    SINGLE_GIFT_IDS[String(id)]=1;
  });

  function root(){
    return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  }

  function cartRedirect(){
    var target=root()+'cart';
    try{
      var current=new URL(window.location.href);
      var params=[];
      ['preview_theme_id','preview_key','pb'].forEach(function(k){
        if(current.searchParams.has(k)){
          params.push(encodeURIComponent(k)+'='+encodeURIComponent(current.searchParams.get(k)));
        }
      });
      if(params.length)target+='?'+params.join('&');
    }catch(e){}
    return target;
  }

  function status(msg,ok){
    var input=document.querySelector('[data-mxp3-promo]');
    if(!input)return;
    var wrap=input.closest('.mxp3promo');
    if(!wrap)return;
    var box=document.querySelector('[data-mxp-promo-bridge-status]');
    if(!box){
      box=document.createElement('div');
      box.setAttribute('data-mxp-promo-bridge-status','1');
      box.style.cssText='margin-top:8px;padding:9px 11px;border-radius:10px;font-size:10.5px;font-weight:850;line-height:1.4';
      wrap.insertAdjacentElement('afterend',box);
    }
    box.style.background=ok?'#eefbf1':'#fff0ed';
    box.style.border='1px solid '+(ok?'#b9e8c2':'#ffc6b8');
    box.style.color=ok?'#176b2c':'#a33116';
    box.textContent=msg;
  }

  function setButton(busy,label){
    var b=document.querySelector('[data-mxp3-apply]');
    if(!b)return;
    b.disabled=!!busy;
    b.textContent=busy?(label||'Application…'):'Appliquer';
  }

  function norm(v){
    var s=String(v||'').toLowerCase();
    try{s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
    return s.replace(/\s+/g,' ').trim();
  }

  function props(item){
    return item&&item.properties&&typeof item.properties==='object'?item.properties:{};
  }

  function isGift(item){
    return String(props(item)._MAXPROMO_Cadeau||'')==='1';
  }

  function isService(item){
    var s=norm([item&&item.product_title,item&&item.title,item&&item.handle,item&&item.product_type].filter(Boolean).join(' '));
    var p=props(item);
    if(/reparat|repair-checkout|reprise|trade.?in|diagnostic/.test(s))return true;
    return Object.keys(p).some(function(k){
      return /reparation|panne|reprise|diagnostic/.test(norm(k));
    });
  }

  function isAccessory(item){
    var type=norm(item&&item.product_type);
    var s=norm([item&&item.product_title,item&&item.title,item&&item.handle,type].filter(Boolean).join(' '));
    if(/accessoire|accessory/.test(type))return true;
    return /chargeur|charger|cable|adaptateur|adapter|prise secteur/.test(s);
  }

  function modelYear(s){
    var m=norm(s).match(/\b(20\d{2}|19\d{2})\b/);
    return m?Number(m[1]):0;
  }

  function generationOf(s){
    var m=norm(s).match(/(?:-|\s)(\d+)(?:e|re)?\s+generation\b/);
    return m?Number(m[1]):0;
  }

  function seriesNumber(s,label){
    var x=norm(s);
    var re=new RegExp(label.replace(/\s+/g,'\\s*')+'\\s*(\\d{1,2})\\b');
    var m=x.match(re);
    return m?Number(m[1]):0;
  }

  function macGiftFor(source){
    var s=norm(source),year=modelYear(s);
    var air=s.indexOf('macbook air')!==-1;
    var pro=s.indexOf('macbook pro')!==-1;
    if(/\bm[1-9]\b|thunderbolt\s*3|usb\s*-?\s*c/.test(s))return V.macUsbC;
    if(air){if(year>=2018)return V.macUsbC;if(year>=2012)return V.macT;return V.macL}
    if(pro){if(year>=2016)return V.macUsbC;if(year>=2012)return V.macT;return V.macL}
    if(year>=2015)return V.macUsbC;
    if(year>=2012)return V.macT;
    if(year&&year<=2011)return V.macL;
    return V.macUsbC;
  }

  function iphoneGiftFor(source){
    var s=norm(source);
    if(/iphone\s*(?:2g|3g|3gs|4|4s)\b/.test(s)||s.indexOf('original iphone')!==-1)return V.pin30;
    if(s.indexOf('iphone air')!==-1)return V.usbAC;
    var m=s.match(/iphone\s*(\d{1,2})\b/);
    if(m){
      var model=Number(m[1]);
      if(model<=4)return V.pin30;
      if(model>=15)return V.usbAC;
      return V.lightning;
    }
    if(s.indexOf('iphone se')!==-1||/iphone\s*(?:x|xs|xr)\b/.test(s))return V.lightning;
    return V.lightning;
  }

  function ipadGiftFor(source){
    var s=norm(source),gen=generationOf(s),year=modelYear(s),n;
    if(s.indexOf('ipad mini')!==-1){
      n=seriesNumber(s,'ipad mini');
      if(n)return n>=6?V.usbAC:V.lightning;
      return gen>=6?V.usbAC:V.lightning;
    }
    if(s.indexOf('ipad air')!==-1){
      n=seriesNumber(s,'ipad air');
      if(n)return n>=4?V.usbAC:V.lightning;
      return gen>=4?V.usbAC:V.lightning;
    }
    if(s.indexOf('ipad pro')!==-1){
      if(/ipad pro\s*11\b/.test(s))return V.usbAC;
      if(/12[.,]9/.test(s)&&gen>=3)return V.usbAC;
      if(year>=2018)return V.usbAC;
      return V.lightning;
    }
    if(gen){if(gen<=3)return V.pin30;if(gen>=10)return V.usbAC;return V.lightning}
    n=seriesNumber(s,'ipad');
    if(n&&n<=3)return V.pin30;
    if(n&&n>=10)return V.usbAC;
    if(n&&n>=4&&n<=9)return V.lightning;
    if(year&&year<=2011)return V.pin30;
    if(year>=2022)return V.usbAC;
    return V.lightning;
  }

  function samsungTabGiftFor(source){
    var s=norm(source),year=modelYear(s),m=s.match(/galaxy tab\s*s(\d+)/);
    if(m)return Number(m[1])>=3?V.usbAC:V.microUsb;
    if(/galaxy tab\s*4\b/.test(s)||/tab active\s*2\b/.test(s))return V.microUsb;
    if(/tab a7\b|tab a8\b|tab a9\b|tab active\s*[345]\b/.test(s))return V.usbAC;
    if(year&&year<=2017)return V.microUsb;
    return V.usbAC;
  }

  function samsungPhoneGiftFor(source){
    var s=norm(source),m=s.match(/galaxy\s*s(\d+)/);
    if(m)return Number(m[1])<=7?V.microUsb:V.usbAC;
    m=s.match(/galaxy\s*note\s*(\d+)/);
    if(m)return Number(m[1])<=5?V.microUsb:V.usbAC;
    if(/galaxy\s*j\d|galaxy\s+j\b/.test(s))return V.microUsb;
    var year=modelYear(s);
    if(year&&year<=2016)return V.microUsb;
    return V.usbAC;
  }

  function otherAndroidGiftFor(source){
    var y=modelYear(source);
    return y&&y<=2017?V.microUsb:V.usbAC;
  }

  function mobileGiftSet(connector){
    return (connector===V.pin30||connector===V.microUsb)
      ? [connector]
      : [V.charger2a,connector];
  }

  function giftIdsFor(item){
    var s=norm([
      item&&item.product_title,
      item&&item.title,
      item&&item.handle,
      item&&item.product_type,
      item&&item.vendor,
      item&&item.variant_title
    ].filter(Boolean).join(' '));

    if(s.indexOf('macbook')!==-1)return [macGiftFor(s)];
    if(s.indexOf('ipad')!==-1)return mobileGiftSet(ipadGiftFor(s));
    if((s.indexOf('samsung')!==-1&&s.indexOf('tab')!==-1)||s.indexOf('galaxy tab')!==-1){
      return mobileGiftSet(samsungTabGiftFor(s));
    }
    if(s.indexOf('iphone')!==-1)return mobileGiftSet(iphoneGiftFor(s));
    if(s.indexOf('samsung')!==-1||s.indexOf('galaxy')!==-1){
      return mobileGiftSet(samsungPhoneGiftFor(s));
    }
    if(/android|xiaomi|redmi|oppo|honor|huawei|motorola|nokia|oneplus|pixel/.test(s)){
      return mobileGiftSet(otherAndroidGiftFor(s));
    }
    return [];
  }

  function planFor(cart){
    var counts={};
    (cart&&Array.isArray(cart.items)?cart.items:[]).forEach(function(item){
      if(isGift(item)||isService(item)||isAccessory(item))return;
      var qty=Math.max(1,Number(item.quantity)||1);
      giftIdsFor(item).forEach(function(id){
        var key=String(id);
        counts[key]=(counts[key]||0)+qty;
      });
    });
    return counts;
  }

  function planHasSingle(plan){
    return Object.keys(plan||{}).some(function(id){
      return SINGLE_GIFT_IDS[String(id)]&&Number(plan[id]||0)>0;
    });
  }

  function planHasPrimary(plan){
    return Object.keys(plan||{}).some(function(id){
      return !SINGLE_GIFT_IDS[String(id)]&&Number(plan[id]||0)>0;
    });
  }

  function promoUseCounts(cart){
    var out={primary:0,single:0};
    (cart&&Array.isArray(cart.items)?cart.items:[]).forEach(function(item){
      if(isGift(item)||isService(item)||isAccessory(item))return;
      var ids=giftIdsFor(item);
      if(!ids.length)return;
      var qty=Math.max(1,Number(item.quantity)||1);
      if(ids.some(function(id){return !!SINGLE_GIFT_IDS[String(id)]}))out.single+=qty;
      else out.primary+=qty;
    });
    return out;
  }

  function fetchCart(){
    return fetch(root()+'cart.js',{
      credentials:'same-origin',
      cache:'no-store',
      headers:{Accept:'application/json'}
    }).then(function(r){
      if(!r.ok)throw new Error('cart');
      return r.json();
    });
  }

  function changeLine(key,quantity){
    return fetch(root()+'cart/change.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({id:key,quantity:Math.max(0,Number(quantity)||0)})
    }).then(function(r){
      if(!r.ok)return r.text().then(function(t){throw new Error(t||'change')});
      return r.json();
    });
  }

  function clearGiftLines(cart){
    var gifts=(cart&&Array.isArray(cart.items)?cart.items:[]).filter(isGift);
    var chain=Promise.resolve(cart);
    gifts.forEach(function(item){
      chain=chain.then(function(){return changeLine(item.key,0)});
    });
    return chain.then(fetchCart);
  }

  function addGift(id,qty,code){
    return fetch(root()+'cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{
        id:Number(id),
        quantity:Math.max(1,Number(qty)||1),
        properties:{
          '_MAXPROMO_Cadeau':'1',
          '_MAXPROMO_Code':String(code||''),
          '_MAXPROMO_Offre':'Accessoires offerts'
        }
      }]})
    }).then(function(r){
      if(!r.ok)return r.text().then(function(t){throw new Error(t||'add')});
      return r.json();
    });
  }

  function addPlan(plan,code){
    var ids=Object.keys(plan||{});
    var chain=Promise.resolve();
    ids.forEach(function(id){
      chain=chain.then(function(){
        return addGift(id,plan[id],code);
      });
    });
    return chain;
  }

  function directGiftPromo(code){
    return fetchCart().then(function(cart){
      var initialPlan=planFor(cart);
      if(!Object.keys(initialPlan).length)return false;

      var uses=promoUseCounts(cart);
      if(uses.primary>10||uses.single>10){
        setButton(false);
        status('Cette offre couvre jusqu’à 10 appareils éligibles par type de remise. Réduisez la quantité pour éviter qu’un accessoire soit facturé.',false);
        return true;
      }

      return clearGiftLines(cart).then(function(cleanCart){
        var plan=planFor(cleanCart);
        if(!Object.keys(plan).length)return false;

        var hasPrimary=planHasPrimary(plan);
        var hasSingle=planHasSingle(plan);
        var stage=hasPrimary?'primary':'single';

        try{
          sessionStorage.setItem(TXN,JSON.stringify({
            code:code,
            plan:plan,
            ts:Date.now(),
            stage:stage
          }));
        }catch(e){}

        var count=Object.keys(plan).reduce(function(sum,id){
          return sum+Math.max(0,Number(plan[id])||0);
        },0);

        status('Ajout de '+count+' accessoire'+(count>1?'s':'')+' offert'+(count>1?'s':'')+'…',true);

        return addPlan(plan,code).then(function(){
          var firstCode=hasPrimary?code:SINGLE_GIFT_CODE;
          var url=root()+'discount/'+encodeURIComponent(firstCode)+'?redirect='+encodeURIComponent(cartRedirect());
          window.location.assign(url);
          return true;
        });
      });
    });
  }

  function promoApi(){
    if(window.MXPPromoGift&&typeof window.MXPPromoGift.apply==='function'){
      return Promise.resolve(window.MXPPromoGift);
    }
    if(loading)return loading;

    loading=new Promise(function(resolve,reject){
      var src=String(window.__MXP_PROMO_GIFT_ASSET__||'').trim();
      if(!src){reject(new Error('promo-asset'));return}

      var existing=document.querySelector('script[data-mxp-promo-bridge-loader="1"]');
      if(existing){
        var start=Date.now();
        var wait=setInterval(function(){
          if(window.MXPPromoGift&&typeof window.MXPPromoGift.apply==='function'){
            clearInterval(wait);
            resolve(window.MXPPromoGift);
          }else if(Date.now()-start>3000){
            clearInterval(wait);
            reject(new Error('promo-timeout'));
          }
        },50);
        return;
      }

      var s=document.createElement('script');
      s.src=src;
      s.async=false;
      s.setAttribute('data-mxp-promo-bridge-loader','1');
      s.onload=function(){
        if(window.MXPPromoGift&&typeof window.MXPPromoGift.apply==='function')resolve(window.MXPPromoGift);
        else reject(new Error('promo-api'));
      };
      s.onerror=function(){reject(new Error('promo-load'))};
      document.head.appendChild(s);
    }).finally(function(){loading=null});

    return loading;
  }

  function fallback(code){
    var url=root()+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(cartRedirect());
    window.location.assign(url);
  }

  function run(code){
    code=String(code||'').trim();
    if(!code){
      status('Saisissez un code promo.',false);
      return;
    }

    setButton(true,'Application…');
    status('Application du code promo…',true);

    if(norm(code)==='mhoma'){
      directGiftPromo(code).then(function(done){
        if(done)return;
        return promoApi().then(function(api){api.apply(code)});
      }).catch(function(){
        setButton(false);
        status('Impossible d’ajouter les accessoires offerts. Réessayez.',false);
      });
      return;
    }

    promoApi().then(function(api){
      api.apply(code);
    }).catch(function(){
      status('Le module promo se recharge…',true);
      fallback(code);
    });
  }

  document.addEventListener('click',function(event){
    var button=event.target&&event.target.closest?event.target.closest('[data-mxp3-apply]'):null;
    if(!button)return;
    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation)event.stopImmediatePropagation();
    var input=document.querySelector('[data-mxp3-promo]');
    run(input?input.value:'');
  },true);

  document.addEventListener('keydown',function(event){
    var input=event.target&&event.target.matches&&event.target.matches('[data-mxp3-promo]')?event.target:null;
    if(!input||event.key!=='Enter')return;
    event.preventDefault();
    event.stopPropagation();
    if(event.stopImmediatePropagation)event.stopImmediatePropagation();
    run(input.value);
  },true);
})();